/**
 * Long Form AI — the inbound WebSocket event contract.
 *
 * Client-side view of the zod schema in `expert-workspace-api`
 * `packages/shared-types/long-form-ai.ts`, which is authoritative and validates producer output;
 * change together, including the Event/Payload split.
 */

import type { Narrative } from "./types";

export const LONG_FORM_AI_EVENT = "long-form-ai-event" as const;

/** The full wire event Data Science produces. */
export interface LongFormAiEvent {
    messageType: typeof LONG_FORM_AI_EVENT;
    sessionId: string;
    /** The room the consumer publishes to; spent once delivered, hence absent from the payload. */
    employeeId: string;
    /** Identity is `(sessionId, sku)` — a re-send for the same pair replaces the prior narrative. */
    sku: string;
    narrative: Narrative;
}

/**
 * What the bus hands a listener, and all the store needs. `messageType` becomes the bus key and
 * `employeeId` is spent on routing, so neither survives to the client.
 *
 * Deliberately NOT mirrored into `@expert/websocket` the way DSO's payload is — that would create a
 * second `Narrative` free to drift. The bus types payloads `any`, so it only needs the event name.
 */
export type LongFormAiEventPayload = Pick<LongFormAiEvent, "sessionId" | "sku" | "narrative">;
